module.exports = __webpack_public_path__ + "img/5.942b0681.jpg";